import React from 'react'

const SubmissionError = ({ message }) => (
  <div style={{ textAlign: 'center', marginBottom: 32 }}>
    {message && (
      <div className="heading heading--h4" style={{ margin: 0 }}>
        {message}
      </div>
    )}
    <h3 className="heading heading--h3" style={{ margin: 0 }}>
      Sorry, something went wrong.
    </h3>
    <p>
      Please try again and if the problem persists email{' '}
      <strong style={{ whiteSpace: 'nowrap' }}>
        hello@visakingsglobal.com
      </strong>
    </p>
  </div>
)

export default SubmissionError
